import { useEffect } from "react";

import { useAuthCredentials } from "hooks/useAuthCredentials";

import { noteAuthenticated } from "./rumMonitoring";

/**
 * Remembers that this page session held valid credentials so a later login
 * screen can be classified as an unexpected session loss.
 *
 * Datadog remains anonymous: neither the access code nor patient user ID is
 * attached to RUM events.
 */
export function useAuthTelemetry(): void {
  const { accessCode } = useAuthCredentials();

  useEffect(() => {
    if (accessCode) {
      noteAuthenticated();
    }
  }, [accessCode]);
}
